import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { MapElementSelectionDetail } from './components/MapElementSelectionDetail';
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { ElementGroup, ElementLabel } from './components/BaseElements';
export const MoveMapElementActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    checked: action.teleport,
    onChange: () => action.setTeleport(true)
  }), "\xA0", t("action_editor.property_map__move_teleport")), /*#__PURE__*/React.createElement(ElementLabel, null, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    checked: !action.teleport,
    onChange: () => action.setTeleport(false)
  }), "\xA0", t("action_editor.property_map_move_pathfinding"))), action.teleport && /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_map_element_from_teleport"),
    selectedElement: action.mapElement,
    elementSetter: action.setMapElement.bind(action),
    parameterTypes: ["actions/MapMarkerValueModel", "actions/NPCOnMapValueModel", "actions/EnemyOnMapValueModel", "actions/AnimationElementValueModel", "actions/AreaTriggerValueModel"],
    getSelectableElements: (map, t) => [...MapElementFilter.filterMapMarkerLabels(map), ...MapElementFilter.filterNPCLabels(map), ...MapElementFilter.filterAnimationLabels(map), ...MapElementFilter.filterIndividualAreaTriggerLabels(map)]
  }), !action.teleport && /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_map_element_from_pathfinding"),
    selectedElement: action.mapElement,
    elementSetter: action.setMapElement.bind(action),
    parameterTypes: ["actions/NPCOnMapValueModel", "actions/EnemyOnMapValueModel"],
    getSelectableElements: (map, t) => [...MapElementFilter.filterNPCLabels(map)]
  }), /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_map_marker_to"),
    selectedElement: action.targetMapMarker,
    elementSetter: action.setTargetMapMarker.bind(action),
    parameterTypes: ["actions/MapMarkerValueModel"],
    getSelectableElements: MapElementFilter.filterMapMarkerLabels,
    limitedToMapId: action.mapElement.isMapSet() ? action.mapElement.mapId : undefined
  }));
});